@for (snack of snackbar.snacks(); track snack.id) {
  <!-- An error is announced at once, a success politely; both close by themselves -->
  <div class="snack" [attr.role]="snack.type === 'danger-snack' ? 'alert' : 'status'" animate.enter="snack-enter" [animate.leave]="leaveAnimation(snack)">
    @if (snack.type === 'danger-snack') {
      <svg class="snack-icon snack-icon-danger" viewBox="0 0 24 24" aria-hidden="true">
        <path d="M12 8V12M12 16H12.01M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z"/>
      </svg>
    } @else {
      <svg class="snack-icon snack-icon-success" viewBox="0 0 24 24" aria-hidden="true">
        <path d="M7.5 12L10.5 15L16.5 9M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z"/>
      </svg>
    }
    <span class="snack-text">{{ snack.message }}</span>
    <app-countdown-close-button [duration]="duration" (closed)="snackbar.close(snack.id)" />
  </div>
}
